import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import mktController from 'controllers/mktController'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps {
  onClick?: () => void;
  text?: string;
}

const FixBackHeader: FC<IProps> = (props: IProps) => {
  const { text, onClick } = props
  const history = useHistoryNew()
  const onBack = () => {
    mktController.goBack(history)
  }
  return (
    <div className='fix-back-header'>
      <div className='back' onClick={onBack}><i className='iconfont icon-BACK-12x' /></div>
      <div className='btn' onClick={onClick}><div>{text}</div><i className='iconfont icon-chevron-right' /></div>
    </div>
  )
}
export default FixBackHeader
